<jml-lib-entity-field-group
  [attachmentComponent]="headerComponent"
  [refreshTrigger]="refreshTrigger"
></jml-lib-entity-field-group>
